import React, { useState } from "react";

//apollo imports
import { ApolloConsumer } from "react-apollo";
import { ApolloClient } from "apollo-client";

//style imports
import styled from "styled-components";
import styVars from "../../styles/variables";

const LoginPage = () => {
  const [username, setStateUsername] = useState("");
  const [usernameRowActive, setStateUserNameRowActive] = useState(false);
  const [password, setStatePassword] = useState("");
  const [passwordRowActive, setStatePasswordRowActive] = useState(false);

  const formIsValid = () => true;

  const signIn = (client: ApolloClient<any>) => {
    if (formIsValid()) {
      client.writeData({ data: { isLoggedIn: true } });
      localStorage.clear();
    }
  };

  return (
    <PageContainer>
      <FormContainer>
        <form>
          <FormTitle>
            <img
              src="./assets/images/spec.PNG"
              alt=""
              style={{ height: "40px", width: "40px" }}
            />
            <H2> Knights' Specs </H2>
          </FormTitle>
          <FormRow selected={usernameRowActive}>
            <label htmlFor="username"> Username </label>
            <input
              id="username"
              type="email"
              autoComplete="username"
              placeholder={usernameRowActive ? "" : "Enter Username"}
              onChange={event => setStateUsername(event.target.value)}
              value={username}
              onFocus={() => setStateUserNameRowActive(true)}
              onBlur={e =>
                e.target.value === "" ? setStateUserNameRowActive(false) : null
              }
            />
          </FormRow>
          <FormRow selected={passwordRowActive}>
            <label htmlFor="password"> Password </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              onChange={event => setStatePassword(event.target.value)}
              value={password}
              placeholder={passwordRowActive ? "" : "Enter Password"}
              onFocus={() => setStatePasswordRowActive(true)}
              onBlur={e =>
                e.target.value === "" ? setStatePasswordRowActive(false) : null
              }
            />
          </FormRow>
          <ApolloConsumer>
            {client => (
              <LargeButton
                type="submit"
                onClick={() => {
                  signIn(client);
                }}
              >
                Sign In
              </LargeButton>
            )}
          </ApolloConsumer>
          <StyledLink>Forgot Password?</StyledLink>
        </form>
      </FormContainer>
    </PageContainer>
  );
};

const FormSV = {
  blue: "#3a76eb",
  labelGrey: "#5d5d5d",
  inputGrey: "#c7c7c7"
};
const PageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

const FormContainer = styled.div`
  display: "block";
  border-radius: 8px;
  background-color: white;
  width: 424px;
  padding: 80px 64px;
`;

interface FormRowProps {
  selected: boolean;
}

const FormRow = styled.div<FormRowProps>`
  color: ${props => (props.selected ? "blue" : "grey")};
  transition: color 5s ease-in-out;
  width: 100%;
  & label {
    color: ${props => (props.selected ? FormSV.blue : FormSV.labelGrey)};
    font-size: 12px;
    font-weight: 500;
    width: 100%;
  }
  & input {
    appearance: none;
    border: 0px;
    border-bottom: 2px solid
      ${props => (props.selected ? FormSV.blue : FormSV.inputGrey)};
    font-size: 16px;
    color: ${p => (p.selected ? "black" : FormSV.inputGrey)};
    margin-bottom: 40px;
    outline: none;
    padding: 6px 0;
    width: 100%;
  }
` as React.FunctionComponent<FormRowProps>;

const FormTitle = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 43.5px;
`;

const H2 = styled.h2`
  display: "inline";
  font-size: 32px;
  margin-left: 16px;
`;

const LargeButton = styled.button`
  background-color: ${FormSV.blue};
  border-radius: 5px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  height: 56px;
  padding: 20px;
  text-transform: uppercase;
  width: 100%;
  line-height: 1;
`;

const StyledLink = styled.a`
  color: ${FormSV.blue};
  display: block;
  font-size: 12px;
  font-weight: 500;
  margin-top: 24px;
  text-align: center;
  cursor: pointer;
`;

export default LoginPage;
